import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-recorder-sync-bar',
  templateUrl: './recorder-sync-bar.component.html',
  styleUrls: ['./recorder-sync-bar.component.scss']
})
export class RecorderSyncBarComponent implements OnInit, OnDestroy {
  @Input() value: any = 0;
  @Input() classes: any = [];
  @Input() newRecorder = false;
  @Output() changed = new EventEmitter<number>();
  @ViewChild('editInput') editInputRef!: ElementRef<HTMLInputElement>;

  min = -1000;
  max = 1000;
  step = 5;
  sync = 0;

  editing   = false;
  editValue = '0';

  private repeatTimer: ReturnType<typeof setTimeout> | null = null;
  private editOpenedAt = 0;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.sync = this.value;
  }

  ngOnDestroy() {
    this.stopRepeat();
  }

  getClasses() {
    return [...this.classes, 'ss-progress-input'].join(' ');
  }

  getProgress() {
    return (this.value - this.min) / (this.max - this.min) * 100;
  }

  getValue() {
    return (this.sync > 0 ? '+' : '') + this.sync + 'ms';
  }

  adjust(delta: number) {
    this.value = Math.max(this.min, Math.min(this.max, this.value + delta));
    this.sync  = this.value;
    this.changed.emit(this.value);
  }

  startRepeat(value: number): void {
    this.adjust(value);
    this.stopRepeat();
    const isSmall = Math.abs(value) <= 5;
    const sign    = value > 0 ? 1 : -1;

    if (isSmall) {
      this.repeatTimer = setTimeout(() => {
        const tick = () => {
          this.adjust(sign);
          this.repeatTimer = setTimeout(tick, 80);
        };
        tick();
      }, 350);
    } else {
      let delay = 300;
      const fire = () => {
        this.adjust(value);
        delay = Math.max(60, delay * 0.75);
        this.repeatTimer = setTimeout(fire, delay);
      };
      this.repeatTimer = setTimeout(fire, 400);
    }
  }

  stopRepeat(): void {
    if (this.repeatTimer !== null) {
      clearTimeout(this.repeatTimer);
      this.repeatTimer = null;
    }
  }

  startEdit(e: MouseEvent): void {
    e.preventDefault();
    this.editValue    = String(this.sync);
    this.editing      = true;
    this.editOpenedAt = Date.now();
    this.cdr.detectChanges();
    const el = this.editInputRef?.nativeElement;
    if (el) { el.focus(); el.select(); }
  }

  commitEdit(): void {
    if (!this.editing) return;
    if (Date.now() - this.editOpenedAt < 150) return;
    const v = parseInt(this.editValue, 10);
    if (!isNaN(v)) {
      this.value = Math.max(this.min, Math.min(this.max, v));
      this.sync  = this.value;
      this.changed.emit(this.value);
    }
    this.editing = false;
  }

  onEditKey(e: KeyboardEvent): void {
    if (e.key === 'Enter')  { e.preventDefault(); this.commitEdit(); }
    if (e.key === 'Escape') { this.editing = false; }
  }

  onSeek(e: any) {
    this.changeValue(e.target.value);
  }

  onChange(e: any) {
    this.sync = parseInt(e.target.value);
  }

  changeValue(value: any) {
    this.sync = parseInt(value);
    this.changed.emit(this.sync);
  }
}
